import React from 'react';
import './Header.scss'
import logo from './logo.svg';

const Header = () => {
    return (
        <header>
            <img src={logo} alt=''></img>
        </header>
    );
}
 
export default Header;